import React, { ReactNode } from "react";
import styles from "./styles.module.scss";

interface IProps {
  icon: ReactNode;
  onClick: () => void;
  isSquare?: boolean;
  small?: boolean;
  tooltip?: string;
  disabled?:boolean
}

export const IconButton = ({
  icon,
  small,
  onClick,
  isSquare,
  tooltip,
  disabled
}: IProps) => (
  <div
    title={tooltip}
    onClick={()=> !disabled && onClick()}
    className={`${styles.root} ${disabled && styles.disabled} ${small && styles.small} ${isSquare &&
      styles.square}`}
  >
    {icon}
  </div>
);
